module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/96.d55a84b3.png";